import React from 'react';

export default () => (
  <svg viewBox="0 0 119.87 109.47" width="20px" height="20px" fill="currentColor">
    <g transform="translate(-0.633 -5.446)">
      <path d="M106.8,22.6l-4.01-1.56l0,0l-9.55-3.68   l-10.91-4.25L72.5,9.3l-8.6-3.34c-1.73-0.68-3.65-0.68-5.38,0L15.68,22.6c-2.24,1.13-3.59,3.49-3.44,5.99v74.09h-4.8   c-3.37-0.37-6.4,2.06-6.77,5.43c-0.37,3.37,2.06,6.4,5.43,6.77c0.45,0.05,0.9,0.05,1.34,0h107.59c3.37-0.37,5.8-3.4,5.43-6.77   c-0.31-2.86-2.57-5.12-5.43-5.43h-4.79V28.59C110.4,26.08,109.04,23.73,106.8,22.6L106.8,22.6z M56.41,94.52l-34.46,0.9v-8.59   l34.51-2.7L56.41,94.52z M56.41,73.75l-34.46,4.51v-8.59l34.51-6.31L56.41,73.75z M56.41,52.99L21.95,61.1v-8.59l34.51-9.92   L56.41,52.99z M56.41,32.23L21.95,43.94v-8.43l34.46-13.43V32.23z" />
    </g>
  </svg>
);
